import React from 'react';

export default class H3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const pr = this.props;

        return (
            <h3 {...pr}>
                {pr.children}
            </h3>
        );
    }

    styles = {};
}
